<template>
  <div class="purchase">
    <header-purchase :title="event.title"
                     :start-date="event.start_date"
                     :end-date="event.end_date"
                     :type="event.type"
                     :venue="event.venue" />
    <steps :active="1" />
    <div class="container-tickets">
      <tickets v-if="event.id && purchaseModel === ''"
               :title="true"
               :purchase-model="purchaseModel" />
      <seatsio v-show="purchaseModel === 'seatsio'"
                 :title="true"
                 :singles-selected="singlesSelected" />
      <purchase-needed :purchase-model="purchaseModel" />
    </div>
    <banner-download-app />
    <fb-pixel v-if="event.facebook_pixel_js"
              :fb-pixel="event.facebook_pixel_js" />
    <ga-pixel v-if="event.google_pixel_js"
              :ga-pixel="event.google_pixel_js" />
    <loader v-show="loading"
            class="load-more-loader"
            :middle="true" />
  </div>
</template>

<script>
import HeaderPurchase from '@/components/header-purchase/HeaderPurchase.vue'
import BannerDownloadApp from '@/components/banner-download-app/BannerDownloadApp.vue'
import PurchaseNeeded from '@/components/purchase-needed/PurchaseNeeded.vue'
import Tickets from '@/components/tickets/Tickets.vue'
import Seatsio from '@/components/seatsio/Seatsio.vue'
import FbPixel from '@/components/pixels/FbPixel.vue'
import GaPixel from '@/components/pixels/GaPixel.vue'
import Loader from '@/components/loader/Loader.vue'
import Steps from '@/components/steps/Steps.vue'

export default {
  layout: 'basic',
  components: {
    HeaderPurchase,
    BannerDownloadApp,
    Tickets,
    Seatsio,
    PurchaseNeeded,
    FbPixel,
    GaPixel,
    Loader,
    Steps
  },
  data: () => ({
    purchaseModel: '',
    singlesSelected: 0,
    waitUserSelectQuantity: undefined,
    loading: true,
    temporary_promoter_terms_option: false,
    temporary_promoter_terms_text: {
      'interestelar-sevilla-2020':
        'https://www.interestelarsevilla.com/wp-content/uploads/2018/09/IE_condiciones-generales.pdf',
      'festival-de-les-arts-2020':
        'https://www.festivaldelesarts.com/wp-content/uploads/docs/festivaldelesarts_condiciones_generales.pdf'
    }
  }),
  computed: {
    event() { 
      return this.$store.state.event.detail
    },
    allTicketsLoaded() {
      return this.$store.state.tickets.allTickets
    }
  },
  async mounted() {
    await this.$store.dispatch('tickets/clean')
    this.temporary_promoter_terms_option = true
    this.$ga.page({
      page: window.location.pathname,
      title: 'Purchase',
      location: window.location.href
    })
    this.loading = false
    this._getPurchaseModel()
  },
  methods: {
    closeUserSelectQuantity(singlesSelected) {
      this.singlesSelected = singlesSelected
      this.waitUserSelectQuantity = false
    },
    setUserSelectQuantityTickets(singlesSelected) {
      this.singlesSelected = singlesSelected
      this.waitUserSelectQuantity = false
    },
    _getPurchaseModel() {
      if (
          (this.$route.query.streaming ||
          (this.$route.query.direct && this.$store.state.event.detail.ticket_distributions.length === 0) ||
          this.$store.state.event.detail.ticket_distributions.length === 0) && 
          ! this.$store.state.event.detail.has_options
      ) {
        this.purchaseModel = ''
      }
      else if (
        this.$store.state.event.detail.ticket_distributions[0] &&
        this.$store.state.event.detail.ticket_distributions[0].system === 'onebox'
      ) {
        this.purchaseModel = 'onebox'
      }
      else if (this.$store.state.event.detail.id && 
        this.$store.state.event.detail.ticket_distributions[0] &&
        this.$store.state.event.detail.ticket_distributions[0].system === 'seatsio'
      ) {
        this.purchaseModel = 'seatsio'
      }
      else if (
        this.$store.state.event.detail.has_options &&
        this.$store.state.event.detail.options.length > 0 &&
        this.$store.state.event.detail.ticket_types_count === 0 &&
        this.$store.state.event.detail.ticket_distributions.length === 0
      ) {
        this.purchaseModel = 'options'
      }
    }
  },
}
</script>
